__turbopack_context__.v({
  "share-button": "share-button-module-scss-module__AIXIYW__share-button",
});
